var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"form-separation-element"}},[_c('div',{staticClass:"form-separation-element"},[_c('hr',{style:(_vm.hrStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }